<template lang="pug">
#section2
  #inicio-consecuencias
    .container-fluid
      .row.mb-5
        .title.mx-auto.d-flex
          img(src="/assets/img/microsite/LasConsecuencias.png")
      .row.content.d-flex
        .col-12.top.p-0
          img.back-img(src="/assets/img/microsite/Oval_Llamadas_Imagen_Mobile.png")
        .col-md-7.text.px-4.d-flex
          p.sub-title.default-text.mb-0  No todo es la cuarentena:
          p.sub-title.neutral-text.bold.mb-0  Lo que nos dicen las llamadas
          p.sub-title.default-yellow-text.bold de auxilio de las mujeres
          p.subtext.default-text.bold Las llamadas por violencia familiar se han mantenido al tope desde febrero de 2020, pero ¿qué puede haber detrás de este incremento? ¿Quiénes son las mujeres que piden ayuda?
          router-link.story-btn(to="/las-consecuencias-llamadas") Leer Blog
        .col-md-5.right.pr-0
          img.back-img(src="/assets/img/microsite/Oval_Llamadas_Imagen.png")




</template>

<script>
export default {
  name: "Section2"
};
</script>

<style lang="scss">
#inicio-consecuencias {
  min-height: 100vh;
  padding: 1rem 0;
  margin-bottom: 10rem;
  .title {
    justify-content: center;
    align-items: center;
    img {
      width: 30vw;
      max-width: 350px;
    }
  }
  .sub-title {
    font-size: 1.9rem;
  }
  .content {
    min-height: 85vh;
    background-image: url("/assets/img/microsite/Oval_Llamadas.svg");
    background-size: cover;
    //text-align: center;
    justify-content: center;
    align-items: center;
    .top {
      display: none;
    }
    .right {
      align-self: center;
      .back-img {
        padding-top: 10%;
        width: 100%;
        height: auto;
        text-align: right;
      }
    }
    .text {
      min-height: 40vh;
      flex-direction: column;
      text-align: center;
      justify-content: center;
      align-items: center;
      line-height: 1;
      font-size: 0.95rem;
      .subtext {
        line-height: 1.75;
      }
      a {
        color: #0a1d59;
      }
      .story-btn {
        font-family: "Oswald", sans-serif;
        border: solid 3px #0a1d59;
        border-radius: 45px;
        font-size: 1.2rem;
        padding: 0.5rem 3.5rem;
        margin: 1rem auto 5rem auto;
      }
      .story-btn:hover {
        background-color: #0a1d59;
        color: #fff;
      }
    }
  }
}
@media (max-width: 500px) {
  #inicio-consecuencias {
    .title {
      img {
        width: auto;
        max-width: 225px;
      }
    }
  }
}
// Small devices
@media (max-width: 767px) {
  #inicio-consecuencias {
    // .title {
    //   img {
    //     width: auto;
    //     max-width: 70vw;
    //   }
    // }
    .sub-title {
      font-size: 1.7rem;
    }
    .content {
      background-image: url("/assets/img/microsite/Oval_Llamadas_Mobile.png") !important;
      padding: 2rem 0;
      align-items: flex-end;
      .text {
        .subtext {
          font-size: 0.8rem;
          line-height: 1.5;
          max-width: 90%;
        }
        .story-btn {
          font-family: "Oswald", sans-serif;
          font-size: 1rem;
          border: solid 2px #0a1d59;
          padding: 0.5rem 2.5rem;
          margin: 0.8rem auto 0.8rem auto;
        }
      }
    }
    .right {
      display: none;
    }
    .top {
      display: block !important;
      img {
        top: -2rem;
        position: relative;
        width: 100%;
      }
    }
  }
}
</style>
